import { Stack, Text } from '@fluentui/react'
import { Bar } from 'react-chartjs-2'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import { PassFailTrend } from '../../api/models'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

type PassFailChartProps = {
  data: PassFailTrend | null
}

const cardStyle = {
  root: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: 8,
    boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
    flex: 1,
  },
}

const PassFailChart = ({ data }: PassFailChartProps) => {
  if (!data || !data.labels.length) return null

  const chartData = {
    labels: data.labels,
    datasets: [
      {
        label: 'Passed',
        data: data.passed,
        backgroundColor: '#5B8A72',
        borderRadius: 3,
      },
      {
        label: 'Failed',
        data: data.failed,
        backgroundColor: '#D4775B',
        borderRadius: 3,
      },
    ],
  }

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'top' as const,
      },
    },
    scales: {
      x: { stacked: true },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: { precision: 0 },
      },
    },
  }

  return (
    <Stack styles={cardStyle} tokens={{ childrenGap: 12 }}>
      <Text variant="mediumPlus" styles={{ root: { fontWeight: 600, color: '#605e5c' } }}>
        Pass / Fail by Day
      </Text>
      <div style={{ height: 300 }}>
        <Bar data={chartData} options={options} />
      </div>
    </Stack>
  )
}

export default PassFailChart
